module.exports = __webpack_public_path__ + "media/images/icon-arrow-right-white-a4683eb6a2a698a3dd14a32eca754eb7.svg";